export default "__VITE_ASSET__BgqyUtoc__"